import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export enum DiscountItemType {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}
export enum DiscountStatus {
  ACTIVE = 'ACTIVE',
  SCHEDULED = 'SCHEDULED',
  INACTIVE = 'INACTIVE',
}

export enum DiscountEligibilityType {
  CAR_CATEGORY = 'CAR_CATEGORY',
  CAR_NAME = 'CAR_NAME',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export interface DiscountEligibility {
  value: string;
  label: string;
  type: DiscountEligibilityType;
}
export interface DiscountItem {
  value: number;
  type: DiscountItemType;
  code: string;
  status: DiscountStatus;
  activationDate: Date;
  usageCount: number;
  eligibilities: Array<DiscountEligibility>;
  maxUsageCount?: number;
  isOneTime?: boolean;
  users?: Array<string>;
  id?: string;
  expirationDate?: Date;
}

interface DiscountValidationResult {
  message: string;
  isValid: boolean;
}

interface InitialState {
  items: Array<DiscountItem>;
  isPending: boolean;
  validationResult: DiscountValidationResult | null;
}
const initialState: InitialState = {
  items: [],
  isPending: false,
  validationResult: null,
};
export const discountsSlice = createSlice({
  name: 'discounts',
  initialState,
  reducers: {
    resetStore: (state) => {
      return {
        ...state,
        ...initialState,
      };
    },
    setDiscountValidationResult: (
      state,
      action: PayloadAction<DiscountValidationResult | null>,
    ) => {
      return {
        ...state,
        validationResult: action.payload,
      };
    },
    setDiscountsPendingStatus: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isPending: action.payload,
      };
    },
    setDiscounts: (state, action: PayloadAction<Array<DiscountItem>>) => {
      return {
        ...state,
        items: action.payload,
      };
    },
    setNewDiscount: (state, action: PayloadAction<DiscountItem>) => {
      return {
        ...state,
        items: state.items.concat(action.payload),
      };
    },

    updateDiscount: (state, action: PayloadAction<DiscountItem>) => {
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload.id ? action.payload : item,
        ),
      };
    },

    removeDiscount: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.payload),
      };
    },
  },
});
